module.exports = __webpack_public_path__ + "static/media/Food1.d2eddd89.jpg";